import axios from '../utils/axios';

export default function getManagerTeamCount(adminId, params) {
    return axios.get(`/admin/${adminId}/get-manager-team-count`, { params });
}
